"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function CommonInput(_a) {
    var name = _a.name, label = _a.label, errors = _a.errors, className = _a.className, children = _a.children, disabled = _a.disabled, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b;
    var wrapperClass = ['form-group'];
    var validationSymbolClass = ['validation-symbol'];
    if (errors && (errors.length > 0 || React.isValidElement(errors))) {
        wrapperClass.push('has-error');
        validationSymbolClass.push('invalid');
    }
    if (className) {
        wrapperClass.push(className);
    }
    var errorDiv;
    if (errors) {
        errorDiv = React.createElement("label", { htmlFor: name, className: 'error label', id: name + "_error" }, errors);
    }
    var labelClass = ['label'];
    if (disabled) {
        wrapperClass.push('disabled');
        labelClass.push('disabled');
    }
    var labelElement = React.createElement("label", { className: labelClass.join(' '), htmlFor: name }, label);
    if (!showLabel) {
        labelElement = React.createElement("label", { id: name + "_label_id", className: labelClass.join(' ') }, label);
    }
    return (React.createElement("div", { className: wrapperClass.join(' ') },
        React.createElement("span", { className: validationSymbolClass.join(' ') }),
        errorDiv,
        labelElement,
        React.createElement("div", { className: 'field' }, children)));
}
exports.default = CommonInput;
